import { createContext } from 'react'

export const RecoverPasswordContext = createContext()
